import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const Image = ({
  source,
  type,
  imageStyles,
  styles,
  classes,
  altText,
  ...rest
}) => {
  const alternativeText = altText
    ? altText
    : source.description
    ? source.description
    : `Ouster High-performance digital lidar solutions`

  switch (true) {
    case type:
      return (
        <GatsbyImage
          image={source[type]}
          className={classes}
          alt={alternativeText}
          imgStyle={imageStyles}
          style={styles}
          {...rest}
        />
      )

    case source.hasOwnProperty('gatsbyImageData'):
      return (
        <GatsbyImage
          image={source.gatsbyImageData}
          {...rest}
          className={classes}
          alt={alternativeText}
          imgStyle={imageStyles}
          style={styles}
        />
      )

    case source.hasOwnProperty('file'):
      return (
        <img
          {...rest}
          className={classes}
          src={source.file.url}
          alt={alternativeText}
          style={styles}
        />
      )

    case source.hasOwnProperty('url'):
      return (
        <img
          {...rest}
          className={classes}
          src={source.url}
          alt={alternativeText}
          style={styles}
        />
      )

    default:
      return <div></div>
  }
}

export default Image
